import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { apiFetch } from '../lib/api'
import { useAuth } from '../context/AuthContext'
import CreateUserForm from './CreateUserForm'

export default function CreateUserPage() {
  const navigate = useNavigate()
  const { currentUser, logout } = useAuth()
  const [clinics, setClinics] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    const loadClinics = async () => {
      try {
        setLoading(true)
        const res = await apiFetch('/api/clinics?limit=100&offset=0')
        const data = res.ok ? await res.json() : []
        setClinics(data)
      } catch (e) {
        setError('Error cargando clínicas')
      } finally {
        setLoading(false)
      }
    }
    loadClinics()
  }, [])

  return (
    <div className="min-h-screen bg-[#F4F6F8] flex">
      {/* Sidebar */}
      <aside className="w-64 bg-gradient-to-b from-[#2c3e50] to-[#34495e] text-white flex flex-col shadow-2xl fixed h-screen">
        {/* Logo */}
        <button onClick={() => navigate('/')} className="p-4 border-b border-white/10 flex justify-center hover:opacity-80 transition-opacity cursor-pointer">
          <img src="/lucvan-logo-web.png" alt="Logo" className="h-16 brightness-0 invert" />
        </button>

        {/* Navegación */}
        <nav className="flex-1 px-3 py-6 space-y-2">
          <button
            onClick={() => navigate('/admin/users')}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-lg font-medium text-gray-300 hover:bg-white/10 hover:text-white transition-all"
          >
            <span className="text-xl text-white">⬅️</span>
            <span>Gestión de Usuarios</span>
          </button>
        </nav>

        {/* Info de usuario */}
        <div className="p-4 border-t border-white/10">
          <div className="mb-3">
            <p className="text-sm font-semibold truncate">{currentUser?.email}</p>
            <p className="text-xs text-gray-400 capitalize">{currentUser?.role || 'admin'}</p>
          </div>
          <button
            onClick={() => { logout(); navigate('/login') }}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 rounded font-medium transition-all"
          >
            <span>Cerrar Sesión</span>
          </button>
        </div>
      </aside>

      {/* Contenido principal */}
      <div className="flex-1 overflow-auto ml-64">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-900">Crear nuevo usuario</h1>
            <p className="text-sm text-gray-500 mt-1">Complete el formulario para invitar un usuario</p>
          </div>

          {loading && <div className="p-4 bg-white rounded shadow">Cargando clínicas...</div>}
          {error && <div className="p-4 text-red-600 bg-red-50 rounded shadow">{error}</div>}
          {!loading && !error && (
            <div className="bg-white rounded shadow p-6">
              <CreateUserForm 
                clinics={clinics}
                onClose={() => navigate('/admin/users')}
                onCreated={() => navigate('/admin/users')}
                onClinicCreated={(c)=>{ if (c) setClinics(prev => [...prev, c]) }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}